import React, { useState } from 'react';
import { EaseDrawer } from '../../libs/EaseDrawer';
import { Text1, Text4, Text5 } from "../../styles";
import { handleApiExceptions, getIndianRupeeNotation } from "../../app_methods";
import { DatePicker, List, Avatar, Icon, Tooltip } from 'antd';
import moment from 'moment';


const VirtualAccountInsightsDrawer = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        created_at: [moment().subtract(3, 'days'), moment()],
    });
    const [insightsData, setInsightsData] = useState({});

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchInsights = async (_filters = {}) => {
        setIsLoading(true);
        const response = await props.va.get_insights({ ...prepFilters(_filters), is_submerchant:props.va.is_submerchant, submerchant:props.va.merchant_id });
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setInsightsData(response.data);
        setIsLoading(false);
    };

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Virtual Account Insights</Text1>
                <Text5 className="d-block" type="secondary" copyable>{props.va.id}</Text5>
            </div>
        )
    };

    const renderFilters = () => {
        return (
            <div className="mb-4 d-flex align-self-right">
                {/* <Text4 className="d-block" strong>Created at</Text4> */}
                <DatePicker.RangePicker
                    className="mr-2"
                    size="small"
                    style={{ width: '60%' }}
                    placeholder="Select Date"
                    value={filters.created_at}
                    format="YYYY-MM-DD"
                    disabledDate={(date) => date.valueOf() > moment().valueOf() || date.valueOf() < moment().subtract(32, 'days')}
                    ranges={{
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                        'This Week': [moment().startOf('week'), moment().endOf('week')],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                        'Last 31 Days': [moment().subtract(31, 'days'), moment()]
                    }}
                    allowClear={false}
                    onChange={value => { fetchInsights({ ...filters, created_at: value }); setFilters({ ...filters, created_at: value }); }}
                />
            </div>
        )
    };

    const renderInsights = () => {
        const transactions_amount = getIndianRupeeNotation(insightsData.transactions_amount || 0);
        const refund_amount = getIndianRupeeNotation(insightsData.refund_amount || 0);
        return (
            <List itemLayout="horizontal" loading={isLoading}>
                <List.Item>
                    <List.Item.Meta
                        avatar={<Avatar icon="caret-right" style={{ color: "rgb(54, 162, 235)", border: "1px solid rgb(54, 162, 235)", backgroundColor: "transparent" }} />}
                        title={<Text4 strong>No. of Transactions</Text4>}
                        description={<Text4>{insightsData.total_transactions}</Text4>}
                    />
                </List.Item>
                <List.Item>
                    <List.Item.Meta
                        avatar={<Avatar style={{ color: "rgb(40, 167, 69)", border: "1px solid rgb(40, 167, 69)", backgroundColor: "transparent" }}>₹</Avatar>}
                        title={<Text4 strong>Total Transaction Amount</Text4>}
                        description={<Text4>₹ {`${transactions_amount.integer}${transactions_amount.decimal ? `.${transactions_amount.decimal}` : ""}`} /-</Text4>}
                    />
                </List.Item>
                <List.Item>
                    <List.Item.Meta
                        avatar={<Avatar icon="caret-right" style={{ color: "rgb(54, 162, 235)", border: "1px solid rgb(54, 162, 235)", backgroundColor: "transparent" }} />}
                        title={<Text4 strong>No. of Refunds</Text4>}
                        description={<Text4>{insightsData.total_refund}</Text4>}
                    />
                </List.Item>
                <List.Item>
                    <List.Item.Meta
                        avatar={<Avatar style={{ color: "red", border: "1px solid red", backgroundColor: "transparent" }}>₹</Avatar>}
                        title={<Text4 strong>Total Refund Amount</Text4>}
                        description={<Text4>₹ {`${refund_amount.integer}${refund_amount.decimal ? `.${refund_amount.decimal}` : ""}`} /-</Text4>}
                    />
                </List.Item>
            </List>
        )
    };

    return (
        <EaseDrawer
            className="virtual-account-insights-wrapper"
            title={false}
            width={450}
            visible={props.visible}
            onOpen={() => { setFilters({ ...filters, created_at: [moment().subtract(3, 'days'), moment()] }); fetchInsights({ ...filters, created_at: [moment().subtract(3, 'days'), moment()] }) }}
            onClose={props.toggleInsightsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderFilters()}
                {renderInsights()}
            </div>
        </EaseDrawer>
    )
};

export { VirtualAccountInsightsDrawer };